// extracted by mini-css-extract-plugin
export default {"showButton":"styles_showButton__dSXVs","buttonActive":"styles_buttonActive__O6EmL","buttonPassive":"styles_buttonPassive__Cqzsp"};